import { auth } from "./firebase";
import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  type ActionCodeSettings,
} from "firebase/auth";

export async function getAdminToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function adminApiRequest(method: string, url: string, data?: unknown): Promise<Response> {
  const token = await getAdminToken();
  const headers: Record<string, string> = {};
  if (data) headers["Content-Type"] = "application/json";
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(url, {
    method,
    headers,
    body: data ? JSON.stringify(data) : undefined,
  });
  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
  return res;
}

export async function adminFetch(url: string): Promise<Response> {
  const token = await getAdminToken();
  return fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export async function adminUpload(formData: FormData): Promise<Response> {
  const token = await getAdminToken();
  return fetch("/api/upload", {
    method: "POST",
    body: formData,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export async function sendAdminMagicLink(email: string): Promise<void> {
  const actionCodeSettings: ActionCodeSettings = {
    url: window.location.href,
    handleCodeInApp: true,
  };
  await sendSignInLinkToEmail(auth, email, actionCodeSettings);
  localStorage.setItem("adminEmailForSignIn", email);
}

export async function completeAdminSignIn(): Promise<boolean> {
  if (!isSignInWithEmailLink(auth, window.location.href)) return false;
  let email = localStorage.getItem("adminEmailForSignIn");
  if (!email) {
    email = window.prompt("Please enter your email to confirm sign-in:") || "";
  }
  if (!email) return false;
  await signInWithEmailLink(auth, email, window.location.href);
  localStorage.removeItem("adminEmailForSignIn");
  return true;
}

export { isSignInWithEmailLink, auth };
